import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
const MainFooter = () => {
  const { t } = useTranslation();
  const currentYear = new Date().getFullYear();

  const handleBackToTop = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="bg-light border-top py-2">
      <div className="container-fluid d-flex justify-content-between align-items-center px-3">
        <p className="mb-0 text-center w-100 text-muted" style={{ fontSize: '0.85rem' }}>
          &copy; 2024–{currentYear} {t("footerCopyRightMessage")}
        </p>
        <Link
          to="#"
          className="btn btn-sm btn-danger rounded-circle float-end"
          onClick={handleBackToTop}
          aria-label="Back to top"
          style={{ width: '35px', height: '35px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
        >
          <i className="bi bi-arrow-up" style={{ fontSize: '0.9rem' }}></i>
        </Link>
      </div>
    </footer>
  );
};

export default MainFooter;
